import { render, staticRenderFns } from "./EditObject.vue?vue&type=template&id=e2326eea&"
import script from "./EditObject.vue?vue&type=script&lang=js&"
export * from "./EditObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports